/* Preserve app mounts and forms; only supplement navigation and stalled loading. */
(() => {
  const page = document.querySelector('[data-mas-programs]');
  if (!page) return;
  page.querySelectorAll('[data-mas-reload]').forEach(button => {
    button.addEventListener('click', () => window.location.reload());
  });
  const rewardsFallback = page.querySelector('[data-mas-rewards-fallback]');
  if (rewardsFallback) {
    let rewardsTimer;
    let rewardsUnavailable = false;
    document.addEventListener('mas:rewards-unavailable', () => { rewardsUnavailable = true; });
    const rewardsIsOpen = () => {
      const panel = document.querySelector('.smile-panel-frame-container');
      if (!panel) return false;
      const style = window.getComputedStyle(panel);
      const box = panel.getBoundingClientRect();
      return style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) !== 0 && box.width > 0 && box.height > 0;
    };
    page.addEventListener('click', event => {
      const link = event.target.closest('a[href="#smile-home"]');
      if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      // Keep Smile's existing hash handler and normal link behaviour intact.
      window.clearTimeout(rewardsTimer);
      rewardsFallback.hidden = !rewardsUnavailable;
      if (rewardsUnavailable) return;
      rewardsTimer = window.setTimeout(() => {
        if (rewardsIsOpen()) return;
        rewardsFallback.hidden = false;
      }, 12000);
    });
    new MutationObserver(() => {
      if (!rewardsFallback.hidden && rewardsIsOpen()) rewardsFallback.hidden = true;
    }).observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden']});
  }
  if (page.dataset.masPrograms !== 'auction') return;
  const mount = page.querySelector('#products_on_auction, #wk_bidding_details');
  const fallback = page.querySelector('[data-mas-auction-fallback]');
  if (!mount || !fallback) return;
  const hasContent = () => Boolean(mount.textContent.trim() || mount.querySelector('img, input, button, iframe, a'));
  const refresh = () => {
    if (!hasContent()) return;
    page.classList.remove('is-empty');
    fallback.hidden = true;
  };
  new MutationObserver(refresh).observe(mount, {childList: true, subtree: true, characterData: true});
  window.setTimeout(() => {
    if (hasContent()) return;
    page.classList.add('is-empty');
    fallback.hidden = false;
  }, 12000);
})();
